import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import {
  Icon, List, ListItem, Loader,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import CustomLink from '../CustomLink';
import { JOB_BONUSES } from '../../queries/job';

const BonusDisplay = ({ user, job }) => {
  const [visible, setVisible] = useState(false);
  const { loading, data } = useQuery(JOB_BONUSES, {
    skip: !visible,
    variables: { id: job.id },
  });

  const totalCredits = (job.bonuses ?? [])
    .map((x) => -x.credits)
    .reduce((sum, credit) => sum + credit, 0)
    .toFixed(2);
  const bonuses = data?.job?.bonuses ?? [];

  return (
    <CustomLink onClick={() => setVisible(!visible)}>
      <div>
        {`${totalCredits} bonus`}
        {!visible && <Icon name="angle right" />}
        {visible && <Icon name="angle down" />}
      </div>
      {visible && loading && <Loader active inline="centered" size="tiny" />}
      {visible && !loading && (
        <List>
          {bonuses.map((bonus) => (
            <ListItem key={bonus.id}>
              {`${moment.tz(bonus.createdAt, user.timeZone).format('llll z')} | ${bonus.description}`}
            </ListItem>
          ))}
        </List>
      )}
    </CustomLink>
  );
};

export default BonusDisplay;
